import React from 'react';
import PropTypes from 'prop-types';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import CogIcon from 'components/pure/utils/icon/CogIcon';
import MenuItem from 'material-ui/MenuItem';
import {browserHistory} from 'react-router';
import EditIcon from 'components/pure/utils/icon/EditIcon';
import TagIcon from 'components/pure/utils/icon/triggers/TagIcon';
import CloneIcon from 'components/pure/utils/icon/triggers/CloneIcon';
import SharingIcon from 'material-ui/svg-icons/social/share';
import TrashIcon from 'components/pure/utils/icon/TrashIcon';
import TriggerRuleActions from 'actions/triggers/TriggerRuleActions';
import confirm from 'utils/confirm';
import noop from 'lodash/noop';
import TriggerRuleInfo from 'records/TriggerRuleInfo';
import './SmartAlertConfig.styl';
import TriggerNameDialog from 'components/triggers/rules/TriggerNameDialog';
import RenameIcon from 'components/pure/utils/icon/triggers/RenameIcon';

const ownedMessage = (
  <div>
    If you'd prefer to turn off this alert but keep it for future reference you can click 'No' and
    then toggle notifications off by clicking the green 'Notify Me' indicator at left. Otherwise, if
    you're sure that you'd like to delete the alert, click 'Yes'.
  </div>
);
const sharedMessage = (
  <div>
    WARNING - this Smart Alert is shared with others. Deleting it will turn off the notification
    both for you and for all others. If you'd prefer to turn off this alert but keep it for future
    reference, you can click 'No' and then toggle notifications off by choosing the 'Sharing' option
    from the Action menu. Otherwise, if you're sure that you'd like to delete the alert, click
    'Yes'.
  </div>
);

export default class SmartAlertConfig extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
      showNameDialog: false,
    };

    this.hideMenu = this.hideMenu.bind(this);
    this.handleClone = this.handleClone.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  hideMenu() {
    this.setState({
      showMenu: false,
    });
  }

  handleDelete() {
    const {rule, sessionUser} = this.props;

    this.hideMenu();
    const isShared = rule.shared || rule.userId !== sessionUser.id;
    confirm(
      isShared ? sharedMessage : ownedMessage,
      'Are you sure you want to delete this Smart Alert?'
    ).then(() => TriggerRuleActions.removeTriggerRule(rule.id), noop);
  }

  handleClone() {
    const {rule} = this.props;

    this.hideMenu();
    TriggerRuleActions.cloneTriggerRule(rule.id);
  }

  render() {
    const {rule, canEdit, canShare, setSharingRule, setTaggingRule} = this.props;
    const {showMenu, showNameDialog} = this.state;

    return (
      <div>
        <IconMenu
          className="action-menu"
          listStyle={{padding: 0}}
          iconButtonElement={
            <IconButton className="action-button" onClick={() => this.setState({showMenu: true})}>
              <CogIcon />
            </IconButton>
          }
          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
          onRequestChange={open => !open && this.hideMenu()}
          open={showMenu}
          useLayerForClickAway={true}>
          <div className="smart-alert-config">
            {canEdit && (
              <MenuItem onClick={() => browserHistory.push(`/admin/actions/${rule.id}/edit`)}>
                <div className="action-menu-item">
                  <EditIcon className="edit-icon" /> <span>Edit Alert</span>
                </div>
              </MenuItem>
            )}
            {canEdit && (
              <MenuItem
                onClick={() => {
                  this.hideMenu();
                  this.setState({showNameDialog: true});
                }}>
                <div className="action-menu-item">
                  <RenameIcon /> <span>Rename Alert</span>
                </div>
              </MenuItem>
            )}
            <MenuItem
              onClick={() => {
                setTaggingRule(rule.id);
                this.hideMenu();
              }}>
              <div className="action-menu-item">
                <TagIcon />
                <span>Edit Tags {rule.tags.size > 0 && <span>({rule.tags.size})</span>}</span>
              </div>
            </MenuItem>
            <MenuItem onClick={this.handleClone}>
              <div className="action-menu-item">
                <CloneIcon />
                <span>Clone</span>
              </div>
            </MenuItem>
            <MenuItem
              disabled={!canShare}
              onClick={() => {
                setSharingRule(rule.id);
                this.hideMenu();
              }}>
              <div className={`action-menu-item ${!canShare && 'disabled'}`}>
                <SharingIcon />
                <span>Share</span>
              </div>
            </MenuItem>
            {canEdit && (
              <MenuItem onClick={this.handleDelete}>
                <div className="action-menu-item">
                  <TrashIcon />
                  <span>Delete</span>
                </div>
              </MenuItem>
            )}
          </div>
        </IconMenu>
        <TriggerNameDialog
          rule={rule}
          open={showNameDialog}
          onCancel={() => this.setState({showNameDialog: false})}
        />
      </div>
    );
  }
}

SmartAlertConfig.propTypes = {
  rule: PropTypes.instanceOf(TriggerRuleInfo),
  canEdit: PropTypes.bool,
  canShare: PropTypes.bool,
  setTaggingRule: PropTypes.func, // RuleId => void
  setSharingRule: PropTypes.func, // RuleId => void
};
